import { Grid, Layout } from '@enterprise-ui/canvas-ui-react'
import { SectionHeader } from './SectionHeader'
import { UnauthorizedPage } from './UnauthorizedPage'
import { UncaughtError } from './UncaughtError'

export const NoAssociatedVendorsPage = ({
  userId,
  associatedVendorsResponse,
}) => {
  return (
    <>
      {associatedVendorsResponse?.status === 403 ? (
        <UnauthorizedPage />
      ) : associatedVendorsResponse?.status === 200 ? (
        <Layout.Body className="hesp-generic-layout" includeRail>
          <Grid.Container>
            <SectionHeader pageHeading="No Associated Vendors" />
            <Grid.Item className="hesp-general-fullwidth hc-pv-none">
              <p>
                Your User ID (<strong>{userId}</strong>) is not currently
                associated with any Vendors. Please contact your administrator
                or visit the VMM app to link your account to Vendors in order to
                use this application.
              </p>
            </Grid.Item>
          </Grid.Container>
        </Layout.Body>
      ) : (
        <UncaughtError errorString="Associated Vendors Request failure" />
      )}
    </>
  )
}
